'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JSX Modules
import Spinner from '../_utils/spinner';
import { calculateDimensions } from '../_utils/tools/image-tools';
// -----------------------------------------------------------
//  FoldedCardProductImage
// -----------------------------------------------------------
export default class FoldedCardProductImage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.updateImageDimensions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.url != this.props.url) {
      this.updateImageDimensions();
    }
  }

  render() {
    if (!this.state.loaded) {
      return <Spinner />;
    }

    const backgroundImages = ['url('+this.props.url+')'],
          backgroundSizes  = [],
          class_names      = ['product-image-selected', 'folded-card'],
          ratio            = this.state.height / this.state.width;

    if (ratio <= 1) {
      class_names.push('landscape');
      backgroundImages.push('url(/stylesheets/walmart/images/fake_folded_card_backs/landscape.png)');
      backgroundSizes.push('93% auto');
      backgroundSizes.push('7% ' + (((ratio * 100) - 10) * 1.6) + '%');
    } else {
      class_names.push('portrait');
      backgroundImages.push('url(/stylesheets/walmart/images/fake_folded_card_backs/portrait.png)');
      backgroundSizes.push('auto 92%');
      backgroundSizes.push(((1 / ratio) * 92 )+ '% 7%');
    }

    return (
      <div className={ classNames(class_names) }
           style={
            {
              backgroundSize:  backgroundSizes.join(','),
              backgroundImage: backgroundImages.join(',')
            }
         }>
      </div>
    );
  }

  updateImageDimensions() {
    calculateDimensions(this.props.url).then(({ height, width }) => {
      this.setState({
        height,
        width,
        loaded: true
      });
    }).catch(() => {
      this.setState({
        loaded: false
      });
    });
  }
}
